var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

(function (b, c) {
  if ('object' == typeof exports && 'object' == typeof module) module.exports = c(require('react'), require('prop-types'), require('classnames'));else if ('function' == typeof define && define.amd) define(['react', 'prop-types', 'classnames'], c);else {
    var d = 'object' == typeof exports ? c(require('react'), require('prop-types'), require('classnames')) : c(b.react, b['prop-types'], b.classnames);

    for (var a in d) {
      ('object' == typeof exports ? exports : b)[a] = d[a];
    }
  }
})(window, function (__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__5__) {
  var _Mathsign = Math.sign;
  return function (a) {
    function b(d) {
      if (c[d]) return c[d].exports;
      var e = c[d] = {
        i: d,
        l: !1,
        exports: {}
      };
      return a[d].call(e.exports, e, e.exports, b), e.l = !0, e.exports;
    }

    var c = {};
    return b.m = a, b.c = c, b.d = function (a, c, d) {
      b.o(a, c) || Object.defineProperty(a, c, {
        enumerable: !0,
        get: d
      });
    }, b.r = function (a) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, {
        value: 'Module'
      }), Object.defineProperty(a, '__esModule', {
        value: !0
      });
    }, b.t = function (a, c) {
      if (1 & c && (a = b(a)), 8 & c) return a;
      if (4 & c && 'object' == typeof a && a && a.__esModule) return a;
      var d = Object.create(null);
      if (b.r(d), Object.defineProperty(d, 'default', {
        enumerable: !0,
        value: a
      }), 2 & c && 'string' != typeof a) for (var e in a) {
        b.d(d, e, function (b) {
          return a[b];
        }.bind(null, e));
      }
      return d;
    }, b.n = function (a) {
      var c = a && a.__esModule ? function () {
        return a['default'];
      } : function () {
        return a;
      };
      return b.d(c, 'a', c), c;
    }, b.o = function (a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }, b.p = '', b(b.s = 11);
  }([function (a) {
    a.exports = __WEBPACK_EXTERNAL_MODULE__0__;
  }, function (a) {
    a.exports = __WEBPACK_EXTERNAL_MODULE__1__;
  }, function (a, b, c) {
    'use strict';

    a.exports = c(12);
  }, function (a) {
    a.exports = {
      Core: '_1ncNYh11bEgDHaKrVgg3AR',
      curr: 'r7OsZg7yeZ9DuLfw2IEiG',
      left: '_1dMDT1m5zXlSxArCEZKgPw',
      right: '_3NJbiiVgEGpfWA-RGgRm8e',
      top: '_23O3tTmRuQSjtOTfZ1a6U7',
      bottom: '_3ToZVinlQtbzwB-45jlba6'
    };
  }, function (a) {
    a.exports = function (a) {
      if (!a.webpackPolyfill) {
        var b = Object.create(a);
        b.children || (b.children = []), Object.defineProperty(b, 'loaded', {
          enumerable: !0,
          get: function get() {
            return b.l;
          }
        }), Object.defineProperty(b, 'id', {
          enumerable: !0,
          get: function get() {
            return b.i;
          }
        }), Object.defineProperty(b, 'exports', {
          enumerable: !0
        }), b.webpackPolyfill = 1;
      }

      return b;
    };
  }, function (a) {
    a.exports = __WEBPACK_EXTERNAL_MODULE__5__;
  }, function (module, __webpack_exports__, __webpack_require__) {
    'use strict';

    (function (module) {
      function ownKeys(a, b) {
        var c = Object.keys(a);
        return Object.getOwnPropertySymbols && c.push.apply(c, Object.getOwnPropertySymbols(a)), b && (c = c.filter(function (b) {
          return Object.getOwnPropertyDescriptor(a, b).enumerable;
        })), c;
      }

      function _objectSpread(a) {
        for (var b, c = 1; c < arguments.length; c++) {
          b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(b, !0).forEach(function (c) {
            _defineProperty(a, c, b[c]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(b).forEach(function (c) {
            Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
          });
        }

        return a;
      }

      function _objectWithoutProperties(a, b) {
        if (null == a) return {};

        var c,
            d,
            e = _objectWithoutPropertiesLoose(a, b);

        if (Object.getOwnPropertySymbols) {
          var f = Object.getOwnPropertySymbols(a);

          for (d = 0; d < f.length; d++) {
            c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
          }
        }

        return e;
      }

      function _objectWithoutPropertiesLoose(a, b) {
        if (null == a) return {};
        var c,
            d,
            e = {},
            f = Object.keys(a);

        for (d = 0; d < f.length; d++) {
          c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
        }

        return e;
      }

      function _defineProperty(a, b, c) {
        return b in a ? Object.defineProperty(a, b, {
          value: c,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : a[b] = c, a;
      }

      var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1),
          prop_types__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__),
          react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0),
          react__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).enterModule;
        a && a(module);
      })();

      var __signature__ = 'undefined' == typeof reactHotLoaderGlobal ? function (b) {
        return b;
      } : reactHotLoaderGlobal.default.signature;

      var Animated = /*#__PURE__*/function (_react__WEBPACK_IMPOR) {
        _inherits(Animated, _react__WEBPACK_IMPOR);

        var _super = _createSuper(Animated);

        function Animated() {
          var _this;

          _classCallCheck(this, Animated);

          _this = _super.apply(this, arguments), _defineProperty(_assertThisInitialized(_this), 'state', {
            selected: _this.props.selected
          }), _defineProperty(_assertThisInitialized(_this), 'rafCallback', function (a) {
            if (!_this.startTime) return _this.startTime = a, void (_this.id = requestAnimationFrame(_this.rafCallback));
            var b = a - _this.startTime,
                c = _this.startSelected + _this.direction * b / _this.props.animationDuration;
            (1 === _this.direction ? c < _this.props.selected : c > _this.props.selected) ? (_this.turn(c), _this.id = requestAnimationFrame(_this.rafCallback)) : _this.turn(_this.props.selected);
          });
          return _this;
        }

        _createClass(Animated, [{
          key: "turn",
          value: function turn(a) {
            var _this2 = this;

            this.setState({
              selected: a
            }, function () {
              var b = _this2.props.onTurn;
              b instanceof Function && b(a);
            });
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(a) {
            if (this.props.animationDuration !== a.animationDuration || this.props.selected !== a.selected) {
              if (cancelAnimationFrame(this.id), this.startSelected = this.state.selected, this.startTime = 0, this.direction = _Mathsign(this.props.selected - this.state.selected), !this.direction) return;
              if (!this.props.animationDuration) return void this.turn(this.props.selected);
              this.id = requestAnimationFrame(this.rafCallback);
            }
          }
        }, {
          key: "render",
          value: function render() {
            var a = this.props,
                b = a.animationDuration,
                c = a.flippingPages,
                d = a.onTurn,
                e = a.selected,
                f = a.willChange,
                g = _objectWithoutProperties(a, ['animationDuration', 'flippingPages', 'onTurn', 'selected', 'willChange']);

            return Object(react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(c, _objectSpread({
              selected: this.state.selected,
              willChange: this.state.selected !== e || f
            }, g));
          }
        }, {
          key: "__reactstandin__regenerateByEval",
          value: function __reactstandin__regenerateByEval(key, code) {
            this[key] = eval(code);
          }
        }]);

        return Animated;
      }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

      _defineProperty(Animated, 'propTypes', {
        animationDuration: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
        flippingPages: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.element.isRequired,
        onTurn: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
        selected: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number.isRequired,
        willChange: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool
      }), _defineProperty(Animated, 'defaultProps', {
        animationDuration: 500,
        willChange: !1
      });
      var _default = Animated;
      __webpack_exports__.a = _default;

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).default;
        a && (a.register(Animated, 'Animated', '/home/naman/Code/flipping-pages/src/Animated.js'), a.register(_default, 'default', '/home/naman/Code/flipping-pages/src/Animated.js'));
      })();

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).leaveModule;
        a && a(module);
      })();
    }).call(this, __webpack_require__(4)(module));
  }, function (module, __webpack_exports__, __webpack_require__) {
    'use strict';

    (function (module) {
      function _extends() {
        return _extends = Object.assign || function (a) {
          for (var b, c = 1; c < arguments.length; c++) {
            for (var d in b = arguments[c], b) {
              Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
            }
          }

          return a;
        }, _extends.apply(this, arguments);
      }

      function _objectWithoutProperties(a, b) {
        if (null == a) return {};

        var c,
            d,
            e = _objectWithoutPropertiesLoose(a, b);

        if (Object.getOwnPropertySymbols) {
          var f = Object.getOwnPropertySymbols(a);

          for (d = 0; d < f.length; d++) {
            c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
          }
        }

        return e;
      }

      function _objectWithoutPropertiesLoose(a, b) {
        if (null == a) return {};
        var c,
            d,
            e = {},
            f = Object.keys(a);

        for (d = 0; d < f.length; d++) {
          c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
        }

        return e;
      }

      function _defineProperty(a, b, c) {
        return b in a ? Object.defineProperty(a, b, {
          value: c,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : a[b] = c, a;
      }

      var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5),
          classnames__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__),
          prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1),
          prop_types__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__),
          react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0),
          react__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__),
          _Core_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3),
          _Core_sass__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_Core_sass__WEBPACK_IMPORTED_MODULE_3__);

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).enterModule;
        a && a(module);
      })();

      var __signature__ = 'undefined' == typeof reactHotLoaderGlobal ? function (b) {
        return b;
      } : reactHotLoaderGlobal.default.signature;

      var Core = /*#__PURE__*/function (_react__WEBPACK_IMPOR2) {
        _inherits(Core, _react__WEBPACK_IMPOR2);

        var _super2 = _createSuper(Core);

        function Core() {
          _classCallCheck(this, Core);

          return _super2.apply(this, arguments);
        }

        _createClass(Core, [{
          key: "getTurn",
          value: function getTurn(a) {
            var b = a % 1;
            return 0 > b && b++, .5 <= b && b--, b *= 2, b;
          }
        }, {
          key: "getRotation",
          value: function getRotation(a, b) {
            return b * ('horizontal' === a ? -90 : 90);
          }
        }, {
          key: "getTransform",
          value: function getTransform(a, b) {
            return 'rotate'.concat('horizontal' === a ? 'Y' : 'X', '(').concat(this.getRotation(a, b), 'deg)');
          }
        }, {
          key: "render",
          value: function render() {
            var a = Math.round;

            var b = this.props,
                c = b.children,
                d = b.className,
                e = b.direction,
                f = b.rootRef,
                g = b.selected,
                h = b.shadowBackground,
                i = b.willChange,
                j = _objectWithoutProperties(b, ['children', 'className', 'direction', 'rootRef', 'selected', 'shadowBackground', 'willChange']),
                k = react__WEBPACK_IMPORTED_MODULE_2__.Children.toArray(c),
                l = k[a(g)],
                m = k[a(g) - 1],
                n = k[a(g) + 1],
                o = this.getTurn(g),
                p = {},
                q = {},
                r = {},
                s = {
              background: h
            },
                t = {},
                u = {},
                v = {
              background: h
            };

            return 0 > o ? (p.opacity = 0, r.transform = this.getTransform(e, o), s.opacity = -o, v.opacity = 0) : 0 < o ? (p.opacity = 0, u.transform = this.getTransform(e, o), v.opacity = o, s.opacity = 0) : (q.visibility = 'hidden', r.visibility = 'hidden', t.visibility = 'hidden', u.visibility = 'hidden'), i && (p.willChange = 'opacity', q.willChange = 'visibility', r.willChange = 'visibility, transform', s.willChange = 'opacity', t.willChange = 'visibility', u.willChange = 'visibility, transform', v.willChange = 'opacity'), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', _extends({
              ref: f,
              className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a.Core, d)
            }, j), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a.curr,
              style: p
            }, l), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a['horizontal' === e ? 'left' : 'top'],
              style: q,
              "aria-hidden": 'true'
            }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a.clipper
            }, m)), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a['horizontal' === e ? 'left' : 'top'],
              style: r,
              "aria-hidden": 'true'
            }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a.clipper
            }, l), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a.shadow,
              style: s
            })), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a['horizontal' === e ? 'right' : 'bottom'],
              style: t,
              "aria-hidden": 'true'
            }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a.clipper
            }, n)), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a['horizontal' === e ? 'right' : 'bottom'],
              style: u,
              "aria-hidden": 'true'
            }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a.clipper
            }, l), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
              className: _Core_sass__WEBPACK_IMPORTED_MODULE_3___default.a.shadow,
              style: v
            })));
          }
        }, {
          key: "__reactstandin__regenerateByEval",
          value: function __reactstandin__regenerateByEval(key, code) {
            this[key] = eval(code);
          }
        }]);

        return Core;
      }(react__WEBPACK_IMPORTED_MODULE_2__.PureComponent);

      _defineProperty(Core, 'propTypes', {
        direction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['horizontal', 'vertical']).isRequired,
        rootRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
        selected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired,
        shadowBackground: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
        willChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
      }), _defineProperty(Core, 'defaultProps', {
        shadowBackground: 'rgba(0,0,0,0.25)',
        willChange: !1
      });
      var _default = Core;
      __webpack_exports__.a = _default;

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).default;
        a && (a.register(Core, 'Core', '/home/naman/Code/flipping-pages/src/Core.js'), a.register(_default, 'default', '/home/naman/Code/flipping-pages/src/Core.js'));
      })();

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).leaveModule;
        a && a(module);
      })();
    }).call(this, __webpack_require__(4)(module));
  }, function (module, __webpack_exports__, __webpack_require__) {
    'use strict';

    (function (module) {
      function ownKeys(a, b) {
        var c = Object.keys(a);
        return Object.getOwnPropertySymbols && c.push.apply(c, Object.getOwnPropertySymbols(a)), b && (c = c.filter(function (b) {
          return Object.getOwnPropertyDescriptor(a, b).enumerable;
        })), c;
      }

      function _objectSpread(a) {
        for (var b, c = 1; c < arguments.length; c++) {
          b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(b, !0).forEach(function (c) {
            _defineProperty(a, c, b[c]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(b).forEach(function (c) {
            Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
          });
        }

        return a;
      }

      function _objectWithoutProperties(a, b) {
        if (null == a) return {};

        var c,
            d,
            e = _objectWithoutPropertiesLoose(a, b);

        if (Object.getOwnPropertySymbols) {
          var f = Object.getOwnPropertySymbols(a);

          for (d = 0; d < f.length; d++) {
            c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
          }
        }

        return e;
      }

      function _objectWithoutPropertiesLoose(a, b) {
        if (null == a) return {};
        var c,
            d,
            e = {},
            f = Object.keys(a);

        for (d = 0; d < f.length; d++) {
          c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
        }

        return e;
      }

      function _defineProperty(a, b, c) {
        return b in a ? Object.defineProperty(a, b, {
          value: c,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : a[b] = c, a;
      }

      var _Mathmin = Math.min,
          _Mathmax = Math.max,
          classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5),
          classnames__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__),
          prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1),
          prop_types__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__),
          react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0),
          react__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__),
          _PointerControl_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10),
          _PointerControl_sass__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_PointerControl_sass__WEBPACK_IMPORTED_MODULE_3__);

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).enterModule;
        a && a(module);
      })();

      var __signature__ = 'undefined' == typeof reactHotLoaderGlobal ? function (b) {
        return b;
      } : reactHotLoaderGlobal.default.signature;

      var PointerControl = /*#__PURE__*/function (_react__WEBPACK_IMPOR3) {
        _inherits(PointerControl, _react__WEBPACK_IMPOR3);

        var _super3 = _createSuper(PointerControl);

        function PointerControl() {
          var _this3;

          _classCallCheck(this, PointerControl);

          _this3 = _super3.apply(this, arguments), _defineProperty(_assertThisInitialized(_this3), 'state', {
            down: !1,
            selected: _this3.props.selected
          }), _defineProperty(_assertThisInitialized(_this3), 'handlePointerDown', function (a) {
            var _this3$props = _this3.props,
                b = _this3$props.onPointerDown,
                c = _this3$props.onSwipeStart;
            !_this3.down && _this3.state.selected === _this3.props.selected && c(a) && (_this3.setState({
              down: !0
            }), _this3.startSelected = _this3.state.selected, _this3.id = a.pointerId, _this3.x = a.clientX, _this3.startX = _this3.x, _this3.lastX = _this3.x, _this3.y = a.clientY, _this3.startY = _this3.y, _this3.lastY = _this3.y, _this3.time = a.timeStamp, _this3.lastTime = _this3.time), b && b(a);
          }), _defineProperty(_assertThisInitialized(_this3), 'handlePointerMove', function (a) {
            _this3.state.down && a.pointerId === _this3.id && (_this3.lastX = _this3.x, _this3.lastY = _this3.y, _this3.x = a.clientX, _this3.y = a.clientY, _this3.lastTime = _this3.time, _this3.time = a.timeStamp, _this3.updateSelectedWhenDown());
          }), _defineProperty(_assertThisInitialized(_this3), 'handlePointerUp', function (a) {
            _this3.state.down && a.pointerId === _this3.id && (_this3.setState({
              down: !1
            }), _this3.updateSelectedWhenUp());
          });
          return _this3;
        }

        _createClass(PointerControl, [{
          key: "getTurn",
          value: function getTurn() {
            var a = 'horizontal' === this.props.direction ? this.startX - this.x : this.startY - this.y;
            this.props.reverse && (a *= -1);
            var b = a / this.props.swipeLength;
            return b;
          }
        }, {
          key: "updateSelectedWhenDown",
          value: function updateSelectedWhenDown() {
            var a = this.getTurn();
            var b = this.props.selected + a;
            b = _Mathmax(b, this.props.selected - 1), b = _Mathmin(b, this.props.selected + 1);
            var c = react__WEBPACK_IMPORTED_MODULE_2__.Children.count(this.props.children);
            0 > b ? b = -this.props.onOverSwipe(-b) : b + 1 > c && (b = this.props.onOverSwipe(b + 1 - c) + c - 1), this.setState({
              selected: b
            });
          }
        }, {
          key: "updateSelectedWhenUp",
          value: function updateSelectedWhenUp() {
            var a = Math.abs;
            this.setState({
              selected: this.props.selected
            });
            var b = this.getTurn();
            var c = ('horizontal' === this.props.direction ? this.lastX - this.x : this.lastY - this.y) / (this.time - this.lastTime);
            this.props.reverse && (c *= -1);
            var d = this.props.selected;
            b ? .5 > a(b) ? a(c) >= this.props.thresholdSpeed && _Mathsign(c) === _Mathsign(b) && (d += _Mathsign(c)) : (a(c) < this.props.thresholdSpeed || _Mathsign(c) !== _Mathsign(b)) && (d += _Mathsign(b)) : a(c) >= this.props.thresholdSpeed && (d += _Mathsign(c)), d = _Mathmax(d, 0), d = _Mathmin(d, react__WEBPACK_IMPORTED_MODULE_2__.Children.count(this.props.children) - 1);
            var e = this.props.onSelectedChange;
            e && e(d);
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(a) {
            this.props.selected !== a.selected && (this.state.down ? (this.setState({
              down: !1
            }), this.updateSelectedWhenUp()) : this.setState({
              selected: this.props.selected
            }));
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            addEventListener('pointermove', this.handlePointerMove), addEventListener('pointerup', this.handlePointerUp), addEventListener('pointercancel', this.handlePointerUp);
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            removeEventListener('pointermove', this.handlePointerMove), removeEventListener('pointerup', this.handlePointerUp), removeEventListener('pointercancel', this.handlePointerUp);
          }
        }, {
          key: "render",
          value: function render() {
            var a = this.props,
                b = a.animationDuration,
                c = a.className,
                d = a.flippingPages,
                e = a.onOverSwipe,
                f = a.onPointerDown,
                g = a.onSelectedChange,
                h = a.onSwipeStart,
                i = a.selected,
                j = a.swipeLength,
                k = a.thresholdSpeed,
                l = _objectWithoutProperties(a, ['animationDuration', 'className', 'flippingPages', 'onOverSwipe', 'onPointerDown', 'onSelectedChange', 'onSwipeStart', 'selected', 'swipeLength', 'thresholdSpeed']);

            return Object(react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(d, _objectSpread({
              animationDuration: this.state.down ? 0 : this.props.animationDuration,
              className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(_PointerControl_sass__WEBPACK_IMPORTED_MODULE_3___default.a.flippingPages, c),
              onPointerDown: this.handlePointerDown,
              selected: this.state.selected,
              willChange: this.state.down
            }, l));
          }
        }, {
          key: "__reactstandin__regenerateByEval",
          value: function __reactstandin__regenerateByEval(key, code) {
            this[key] = eval(code);
          }
        }]);

        return PointerControl;
      }(react__WEBPACK_IMPORTED_MODULE_2__.PureComponent);

      _defineProperty(PointerControl, 'propTypes', {
        animationDuration: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        direction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['horizontal', 'vertical']).isRequired,
        flippingPages: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.element.isRequired,
        onOverSwipe: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onSelectedChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        onSwipeStart: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
        reverse: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
        selected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired,
        swipeLength: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        thresholdSpeed: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
      }), _defineProperty(PointerControl, 'defaultProps', {
        animationDuration: 400,
        onOverSwipe: function onOverSwipe(a) {
          return a / 4;
        },
        onSwipeStart: function onSwipeStart(a) {
          return a.isPrimary;
        },
        reverse: !1,
        swipeLength: 400,
        thresholdSpeed: .1
      });
      var _default = PointerControl;
      __webpack_exports__.a = _default;

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).default;
        a && (a.register(PointerControl, 'PointerControl', '/home/naman/Code/flipping-pages/src/PointerControl.js'), a.register(_default, 'default', '/home/naman/Code/flipping-pages/src/PointerControl.js'));
      })();

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? __webpack_require__(2) : reactHotLoaderGlobal).leaveModule;
        a && a(module);
      })();
    }).call(this, __webpack_require__(4)(module));
  }, function (a, b, c) {
    'use strict';

    (function (a) {
      function d(a, b) {
        var c = Object.keys(a);
        return Object.getOwnPropertySymbols && c.push.apply(c, Object.getOwnPropertySymbols(a)), b && (c = c.filter(function (b) {
          return Object.getOwnPropertyDescriptor(a, b).enumerable;
        })), c;
      }

      function e(a) {
        for (var b, c = 1; c < arguments.length; c++) {
          b = null == arguments[c] ? {} : arguments[c], c % 2 ? d(b, !0).forEach(function (c) {
            f(a, c, b[c]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : d(b).forEach(function (c) {
            Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
          });
        }

        return a;
      }

      function f(a, b, c) {
        return b in a ? Object.defineProperty(a, b, {
          value: c,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : a[b] = c, a;
      }

      function g(a, b) {
        if (null == a) return {};
        var c,
            d,
            e = h(a, b);

        if (Object.getOwnPropertySymbols) {
          var f = Object.getOwnPropertySymbols(a);

          for (d = 0; d < f.length; d++) {
            c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
          }
        }

        return e;
      }

      function h(a, b) {
        if (null == a) return {};
        var c,
            d,
            e = {},
            f = Object.keys(a);

        for (d = 0; d < f.length; d++) {
          c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
        }

        return e;
      }

      var i = c(1),
          j = c.n(i),
          k = c(0),
          l = c.n(k);

      (function () {
        var b = ('undefined' == typeof reactHotLoaderGlobal ? c(2) : reactHotLoaderGlobal).enterModule;
        b && b(a);
      })();

      'undefined' == typeof reactHotLoaderGlobal ? function (b) {
        return b;
      } : reactHotLoaderGlobal.default.signature;
      var m = Object(k.memo)(function (a) {
        var b = a.children,
            c = a.flippingPages,
            d = a.reverse,
            f = a.selected,
            h = g(a, ['children', 'flippingPages', 'reverse', 'selected']),
            i = k.Children.toArray(b);
        return Object(k.cloneElement)(c, e({
          selected: d ? i.length - f - 1 : f
        }, h), d ? i.reverse() : i);
      });
      m.propTypes = {
        flippingPages: j.a.element.isRequired,
        reverse: j.a.bool,
        selected: j.a.number.isRequired
      }, m.defaultProps = {
        reverse: !1
      };
      var n = m;
      b.a = n;

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? c(2) : reactHotLoaderGlobal).default;
        a && (a.register(m, 'Reverse', '/home/naman/Code/flipping-pages/src/Reverse.js'), a.register(n, 'default', '/home/naman/Code/flipping-pages/src/Reverse.js'));
      })();

      (function () {
        var b = ('undefined' == typeof reactHotLoaderGlobal ? c(2) : reactHotLoaderGlobal).leaveModule;
        b && b(a);
      })();
    }).call(this, c(4)(a));
  }, function (a) {
    a.exports = {
      flippingPages: '_2BXhR9UHrnlpm_nHq7-PdZ'
    };
  }, function (a, b, c) {
    'use strict';

    c.r(b), function (a) {
      function d() {
        return d = Object.assign || function (a) {
          for (var b, c = 1; c < arguments.length; c++) {
            for (var d in b = arguments[c], b) {
              Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
            }
          }

          return a;
        }, d.apply(this, arguments);
      }

      function e(a, b) {
        if (null == a) return {};
        var c,
            d,
            e = f(a, b);

        if (Object.getOwnPropertySymbols) {
          var g = Object.getOwnPropertySymbols(a);

          for (d = 0; d < g.length; d++) {
            c = g[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
          }
        }

        return e;
      }

      function f(a, b) {
        if (null == a) return {};
        var c,
            d,
            e = {},
            f = Object.keys(a);

        for (d = 0; d < f.length; d++) {
          c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
        }

        return e;
      }

      var g = c(0),
          h = c.n(g),
          i = c(6),
          j = c(7),
          k = c(8),
          l = c(9);

      (function () {
        var b = ('undefined' == typeof reactHotLoaderGlobal ? c(2) : reactHotLoaderGlobal).enterModule;
        b && b(a);
      })();

      'undefined' == typeof reactHotLoaderGlobal ? function (b) {
        return b;
      } : reactHotLoaderGlobal.default.signature;
      var m = Object(g.memo)(function (a) {
        var b = a.children,
            c = e(a, ['children']);
        return h.a.createElement(k.a, d({
          flippingPages: h.a.createElement(i.a, {
            selected: 0,
            flippingPages: h.a.createElement(l.a, {
              selected: 0,
              flippingPages: h.a.createElement(j.a, {
                direction: 'horizontal',
                selected: 0
              })
            })
          })
        }, c), b);
      });
      m.propTypes = Object.assign({}, j.a.propTypes, l.a.propTypes, i.a.propTypes, k.a.propTypes), delete m.propTypes.flippingPages, delete m.propTypes.willChange, m.defaultProps = Object.assign({}, j.a.defaultProps, l.a.defaultProps, i.a.defaultProps, k.a.defaultProps), delete m.defaultProps.willChange;
      var n = m;
      b['default'] = n;

      (function () {
        var a = ('undefined' == typeof reactHotLoaderGlobal ? c(2) : reactHotLoaderGlobal).default;
        a && (a.register(m, 'FlippingPages', '/home/naman/Code/flipping-pages/src/FlippingPages.js'), a.register(n, 'default', '/home/naman/Code/flipping-pages/src/FlippingPages.js'));
      })();

      (function () {
        var b = ('undefined' == typeof reactHotLoaderGlobal ? c(2) : reactHotLoaderGlobal).leaveModule;
        b && b(a);
      })();
    }.call(this, c(4)(a));
  }, function (a, b, c) {
    'use strict';

    function d(a) {
      return a && 'object' == typeof a && 'default' in a ? a.default : a;
    }

    function f(a) {
      return f.warnAboutHMRDisabled && (f.warnAboutHMRDisabled = !0, console.error('React-Hot-Loader: misconfiguration detected, using production version in non-production environment.'), console.error('React-Hot-Loader: Hot Module Replacement is not enabled.')), g.Children.only(a.children);
    }

    Object.defineProperty(b, '__esModule', {
      value: !0
    });
    var g = d(c(0));
    f.warnAboutHMRDisabled = !1;

    var e = function a() {
      return a.shouldWrapWithAppContainer ? function (a) {
        return function (b) {
          return g.createElement(f, null, g.createElement(a, b));
        };
      } : function (a) {
        return a;
      };
    };

    e.shouldWrapWithAppContainer = !1;
    b.AppContainer = f, b.hot = e, b.areComponentsEqual = function (a, b) {
      return a === b;
    }, b.setConfig = function () {}, b.cold = function (a) {
      return a;
    }, b.configureComponent = function () {};
  }]);
});